var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1A86E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1786 21.125C22.1429 21.125 21.6786 21.6875 20 21.6875C18.2857 21.6875 17.8214 21.125 16.7857 21.125C14.1429 21.125 12 23.2695 12 25.8711V27.3125C12 28.2617 12.75 29 13.7143 29H26.2857C27.2143 29 28 28.2617 28 27.3125V25.8711C28 23.2695 25.8214 21.125 23.1786 21.125ZM26.8571 27.3125C26.8571 27.6289 26.5714 27.875 26.2857 27.875H13.7143C13.3929 27.875 13.1429 27.6289 13.1429 27.3125V25.8711C13.1429 23.8672 14.75 22.25 16.7857 22.25C17.5 22.25 18.1786 22.8125 20 22.8125C21.7857 22.8125 22.5 22.25 23.1786 22.25C25.2143 22.25 26.8571 23.8672 26.8571 25.8711V27.3125ZM20 20C22.5 20 24.5714 17.9961 24.5714 15.5C24.5714 13.0391 22.5 11 20 11C17.4643 11 15.4286 13.0391 15.4286 15.5C15.4286 17.9961 17.4643 20 20 20ZM20 12.125C21.8571 12.125 23.4286 13.6719 23.4286 15.5C23.4286 17.3633 21.8571 18.875 20 18.875C18.1071 18.875 16.5714 17.3633 16.5714 15.5C16.5714 13.6719 18.1071 12.125 20 12.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fe24a084.svg";
export { ForwardRef as ReactComponent };